<template>
  <!-- Rendered only when there is something to say: an app with no links and
       the credit switched off leaves no empty strip under the card. -->
  <footer v-if="links.length || poweredBy" class="sh-foot-links">
    <nav v-if="links.length" class="sh-foot-links__row" aria-label="Help and legal">
      <a
        v-for="link in links"
        :key="link.key"
        :href="link.href"
        :class="`sh-foot-links__${link.key}`"
        :target="link.href.startsWith('mailto:') ? undefined : '_blank'"
        rel="noopener noreferrer"
        >{{ link.label }}</a
      >
    </nav>
    <span v-if="poweredBy" class="sh-foot-links__credit">Powered by Metaship</span>
  </footer>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useSessionStore } from "@/stores/session";
import { preAuthLinks, showPoweredBy } from "@/tenant/loginLinks";

/** Support, legal and the vendor credit — the same strip under every
 *  pre-auth card (Login, OrgPicker, NoAccess, Unavailable). */
export default defineComponent({
  name: "PreAuthFooter",
  setup() {
    const session = useSessionStore();
    const links = computed(() => preAuthLinks(session.tenant?.loginPage));
    const poweredBy = computed(() => showPoweredBy(session.tenant?.loginPage, session.tenant?.name || "Metaship"));
    return { links, poweredBy };
  },
});
</script>
